const cards = [
  {
    title: '鬼灭之刃 柱训练篇',
    tag: '热播中',
    tagColor: 'bg-primary-100 text-primary-700',
    desc: '炭治郎一行人在柱们的指导下展开严酷训练，为最终决战做准备。画面精良、战斗场面燃爆，本季最强番之一。',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20anime%20illustration%20with%20dynamic%20sword%20action%20scene%2C%20warm%20fire%20and%20water%20breathing%20effects%2C%20rich%20dark%20red%20and%20blue%20color%20palette%2C%20clean%20simple%20background%2C%20cinematic%20composition%2C%20no%20text%2C%20no%20characters%20clearly%20visible%2C%20abstract%20energy%20waves&width=800&height=500&seq=card-demon-slayer&orientation=landscape',
    alt: '鬼灭之刃 柱训练篇 - 高清动漫在线观看',
  },
  {
    title: '葬送的芙莉莲',
    tag: '高分推荐',
    tagColor: 'bg-accent-100 text-accent-700',
    desc: '勇者一行人打败魔王后，精灵魔法使芙莉莲踏上了了解人类的旅程。细腻情感与深刻哲思，年度治愈神作。',
    img: 'https://readdy.ai/api/search-image?query=A%20peaceful%20stylized%20anime%20landscape%20with%20soft%20golden%20sunlight%20through%20trees%2C%20gentle%20magical%20particles%2C%20warm%20cream%20and%20green%20tones%2C%20fantasy%20atmosphere%2C%20clean%20simple%20background%2C%20no%20text%2C%20no%20characters%2C%20serene%20mood&width=800&height=500&seq=card-frieren&orientation=landscape',
    alt: '葬送的芙莉莲 - 动漫全集在线看',
  },
  {
    title: '我推的孩子 第二季',
    tag: '热播中',
    tagColor: 'bg-primary-100 text-primary-700',
    desc: '演艺圈题材人气续作，阿库亚的复仇计划持续推进。剧情紧凑反转不断，偶像与悬疑的完美融合。',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20anime%20illustration%20with%20stage%20lights%20and%20sparkles%2C%20showbiz%20atmosphere%2C%20purple%20and%20pink%20gradient%20lighting%2C%20dramatic%20spotlight%20effects%2C%20clean%20simple%20background%2C%20no%20text%2C%20no%20characters%2C%20glamorous%20mood&width=800&height=500&seq=card-oshi-no-ko&orientation=landscape',
    alt: '我推的孩子 第二季 - 番剧在线观看',
  },
  {
    title: '怪兽8号',
    tag: '人气新番',
    tagColor: 'bg-secondary-100 text-secondary-700',
    desc: '32岁清洁工意外获得变身怪兽的能力，加入防卫队对抗怪兽入侵。热血王道作品，战斗场面极具冲击力。',
    img: 'https://readdy.ai/api/search-image?query=A%20dynamic%20stylized%20anime%20illustration%20with%20cityscape%20and%20energy%20explosions%2C%20military%20action%20theme%2C%20dark%20teal%20and%20orange%20contrast%2C%20dramatic%20lighting%2C%20clean%20simple%20background%2C%20no%20text%2C%20no%20characters%2C%20intense%20mood&width=800&height=500&seq=card-kaiju-no8&orientation=landscape',
    alt: '怪兽8号 - 最新动漫在线看',
  },
  {
    title: '迷宫饭',
    tag: '搞笑美食',
    tagColor: 'bg-secondary-100 text-secondary-700',
    desc: '在迷宫中靠吃魔物生存下去！脑洞大开的奇幻美食番，将RPG冒险与料理完美结合，每集都让人垂涎欲滴。',
    img: 'https://readdy.ai/api/search-image?query=A%20whimsical%20stylized%20anime%20illustration%20of%20a%20cozy%20campfire%20cooking%20scene%20in%20a%20fantasy%20dungeon%2C%20warm%20orange%20firelight%2C%20stone%20walls%2C%20delicious%20food%20presentation%2C%20clean%20simple%20background%2C%20no%20text%2C%20no%20characters%2C%20appetizing%20mood&width=800&height=500&seq=card-dungeon-meshi&orientation=landscape',
    alt: '迷宫饭 - 动漫网站在线观看',
  },
  {
    title: '防风少年',
    tag: '热血校园',
    tagColor: 'bg-accent-100 text-accent-700',
    desc: '转学生来到以打架闻名的风铃高中，为守护学校而战。热血校园格斗题材，角色魅力十足打斗酣畅淋漓。',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20anime%20illustration%20of%20a%20school%20rooftop%20at%20sunset%2C%20cherry%20blossom%20trees%20around%20campus%2C%20warm%20golden%20hour%20lighting%2C%20youthful%20energy%2C%20clean%20simple%20background%2C%20no%20text%2C%20no%20characters%2C%20hopeful%20atmosphere&width=800&height=500&seq=card-wind-breaker&orientation=landscape',
    alt: '防风少年 - 动画片在线看',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            热门番剧
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精选人气动漫在线观看，每日更新追番不等待
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden group cursor-pointer hover:border-primary-200/60 transition-colors duration-300"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className={`inline-block px-2.5 py-1 rounded-full text-xs font-medium ${card.tagColor}`}>
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-semibold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}